import React, { Component } from 'react';
import { connect } from 'react-redux';
import AuthHOC from './Auth';
import { withAlert } from 'react-alert';
import Dropzone from 'react-dropzone';
import CloudUpload from '@mui/icons-material/CloudUploadOutlined';
import CloudDone from '@mui/icons-material/CloudDoneOutlined';
import FileDropSelectionModal from '../components/modals/FileDropSelectionModal';
import { Flag } from 'flagger/react';

class FileDropView extends Component {
  constructor(props) {
    super(props);

    this.state = {
      dropdownOpen: false,
      selectedDocument: [],
      documentTypes: [],
      associated_templates: [],
      displayTemplateEditorModal: false,
      displayNewConfigModal: false,
      dropComplete: false,
      fileSelectModalVisible: false,
      dropError: null,
    };
  }

  componentDidUpdate = (prevProps, prevState) => {
    if (
      this.state.selectedDocument &&
      this.state.selectedDocument !== prevState.selectedDocument
    ) {
      this.attemptSave();
    }
  };

  onDragEnter = () => {
    this.setState({
      dropzoneActive: true,
    });
  };

  onDragLeave = () => {
    this.setState({
      dropzoneActive: false,
    });
  };

  onDrop = (files) => {
    this.setState({
      selectedDocument: files,
      // selectedFileName: files[0].name,
      dropzoneActive: false,
    });
  };

  attemptSave = () => {
    const { parsed, userReducer } = this.props;

    let parentDocRef = parsed.ParentDocumentRef || parsed.DocumentRef;

    if (parsed.DocumentType === 'POP') {
      this.setState({
        fileSelectModalVisible: true,
      });

      return;
    }

    for (let i in this.state.selectedDocument) {
      let doc = this.state.selectedDocument[i];

      var metaData = {
        CabinetType: 'X3',
        CabinetId: 1,
        PortfolioType: '',
        PortfolioId: {},
        DocumentType: parsed.DocumentType,
        DocumentID: parsed.DocumentRef,
        Folder: parsed.Folder,
        TransactionType: parsed.TransactionType,
        Company: parsed.Company,
        TransactionValue: parsed.TransactionValue,
        TransactionDate: parsed.TransactionDate,
        TransactionNumber: parsed.TransactionNumber,
        Version: '1',
        DateTimeCreated: Date.now(),
        ImportType: 'Manual',
        UserName: userReducer.user, //todo - this needs to be sorted during security
        ArchiveUser:parsed.ArchiveUser,
        Status: 'Active',
        Pages: 1,
        Language: 'BRI', //todo - this needs to be sorted during security
        ActionData: {},
        DocumentData: {},
        FileId: {},
        AttachmentLocation: '',
        BPNUMBER: parsed.BPNUMBER,
        BPCNUMBER: parsed.BPCNUMBER,
        BPSNUMBER: parsed.BPSNUMBER,
        BPNAME: parsed.BPNAME,
        OrderRef: parsed.OrderRef,
        Currency: parsed.Currency,
      };

      var data = new FormData();

      //apend the file and then the meta data as seperate parms
      data.append('document', doc);
      data.append('metaData', JSON.stringify(metaData));
      data.append('parentType', parsed.DocumentType);
      data.append('parentRef', parentDocRef);

      fetch(
        window.location.protocol +
          '//' +
          window.location.host +
          '/api/archive/file_drop_document',
        {
          method: 'POST',
          body: data,
        }
      )
        .then(async (response) => {
          if (!response.ok) {
            const errorData = await response.json();
            throw new Error(errorData.error);
          }
          this.setState({ dropComplete: true, dropError: null });
        })
        .catch((error) => {
          this.setState({
            dropComplete: false,
            dropError: error.message, // Save the error message in state
          });
        });
    }
  };

  render() {
    let docTypeSelectModal = <div />;

    const overlayStyle = {
      position: 'absolute',
      top: 0,
      right: 0,
      bottom: 0,
      left: 0,
      padding: '100px 20px',
      textAlign: 'center',
      fontSize: '2em',
      color: '#5f6368',
      backgroundColor: this.state.dropzoneActive ? '#f5f5f5' : '#fff',
      outline: '2px dashed #5f6368',
      outlineOffset: '-10px',
    };

    const { parsed, userReducer } = this.props;

    if (parsed.DocumentType == 'POP')
      docTypeSelectModal = (
        <FileDropSelectionModal
          visible={this.state.fileSelectModalVisible}
          toggleAddModal={() =>
            this.setState({
              fileSelectModalVisible: !this.state.fileSelectModalVisible,
              dropComplete: true,
            })
          }
          fileData={this.state.selectedDocument}
          fileName={this.state.selectedFileName}
          parentType={parsed.DocumentType}
          parentRef={parsed.DocumentRef}
        />
      );

    return (
      <>
        <Flag flag="CloudDeployment" entity={{ id: 1 }} case="on">
          <div style={{ position: 'relative', width: window.innerWidth, height: window.innerHeight, ...overlayStyle }}>
            <CloudUpload fontSize={'inherit'} style={{ fontSize: '4rem', color: '#bdbdbd' }} />
            <p><strong>File drop is not available in cloud deployments.</strong></p>
          </div>
        </Flag>
        <Flag flag="CloudDeployment" entity={{ id: 1 }} case="off">
          <Dropzone
            style={{
              position: 'relative',
              width: window.innerWidth,
              height: window.innerHeight,
            }}
            accept=".csv,.doc,.docx,.dwf,.dwg,.eml,.epub,.exif,.gif,.htm,.html,.jpeg,.jpg,.mdb,.md,.msg,.odt,.pcl,.pcx,.pdf,.png,.ppt,.pptx,.psd,.pst,.rar,.raw,.rtf,.tex,.tif,.tiff,.txt,.webp,.xls,.xlsx,.xml,.zip,.7z"
            onDrop={this.onDrop}
            onDragEnter={this.onDragEnter}
            onDragLeave={this.onDragLeave}
          >
            {this.state.dropComplete ? (
              <>
                <div style={overlayStyle}>
                  <CloudDone fontSize={'inherit'} style={{ fontSize: '4rem' }} />
                  <p>
                    <strong>File upload complete</strong> select or drop additional
                    files ...
                  </p>
                </div>
              </>
            ) : (
              <div style={overlayStyle}>
                <CloudUpload fontSize={'inherit'} style={{ fontSize: '4rem' }} />
                <p>
                  <strong>Choose a file</strong> or drag it here.
                </p>
                {this.state.dropError && (
                  <p style={{ color: 'red', textAlign: 'center' }}>
                    {this.state.dropError}
                  </p>
                )}
              </div>
            )}
            {docTypeSelectModal}
          </Dropzone>
        </Flag>
      </>
    );
  }
}
export default connect((state) => state)(
  withAlert()(AuthHOC(FileDropView, { name: 'file_drop' }))
);
